var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClaimSymbolEco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 33,
    viewBox: "0 0 41 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1683_6509",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 33
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 33,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1683_6509)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.84,
    cy: 29.6996,
    rx: 28.4267,
    ry: 28.6,
    fill: "#2DB875"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3122 4.13543C33.2411 3.96247 33.0734 3.84965 32.8874 3.84961C15.0509 3.84961 13.1201 11.2884 13.1201 14.487C13.1201 18.6366 16.2608 21.4245 20.9351 21.4245C26.8386 21.4245 28.0752 15.7728 28.739 12.736C29.3843 9.64487 30.9435 6.82223 33.212 4.63862C33.3433 4.50663 33.3828 4.30813 33.3122 4.13543Z",
    fill: "#3CD58B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5798 24.1997C13.3259 24.1997 13.1201 23.9926 13.1201 23.7371C13.1201 20.9871 17.8597 12.1636 25.3317 8.52098C25.5602 8.40963 25.8352 8.50568 25.9459 8.73557C26.0566 8.96546 25.9611 9.24209 25.7326 9.35348C18.187 13.0322 14.0395 21.5755 14.0395 23.7372C14.0395 23.9926 13.8337 24.1997 13.5798 24.1997Z",
    fill: "#62EFAB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimSymbolEco);
export default __webpack_public_path__ + "static/media/claim-symbol-eco.112c289bd929fa1475af1372b90e8d0c.svg";
export { ForwardRef as ReactComponent };